<template>
    <div class="wrapper-form-input-multiplaescolha" :class="{'allow-markup-error': markupError}" :inert="!isPreenchimento">
        <p v-if="campo.tituloHtml && (isPreenchimento || pIsConferencia)" class="is-size-6 mb-2 titulo-campo-preenchivel" v-html="campo.tituloHtml"></p>
        <div class="control" v-for="(opcao, index) in opcoesOrdenadas" :key="opcao.id? opcao.id : opcao.ordem? opcao.ordem : index">
            <label class="radio">
                <input type="radio" :checked="formData.respostaOpcoes.includes(opcao.ordem)" :value="opcao.ordem" :name="radioGroupGUID" @change="setValue" />
                <span class="ml-2" v-html="opcao.labelHtml? opcao.labelHtml : opcao.label"></span>
            </label>
        </div>
        <p v-if="isInvalida" class="error-message">
            Campo obrigatório!
        </p>
    </div>
  </template>
  <script>
  import { gerarGUID } from '../../../util/uuid.utils';
  import CampoPersonalizado from '../../CampoForm/models/campoPersonalizado.model';
  export default {
    name: 'TrfPreenchimentoMultiplaEscolha',
    emits: ['update:value', 'set:validacao'],
    props: {
        pCampo: {
            type: Object,
            default: new CampoPersonalizado()
        },
        pIsDirty: {
            type: Boolean,
            default: false
        },
        pSocioEmPreenchimento: {
            type: Object,
            default: () => {}
        },
        isPreenchimento: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        pIsConferencia: {
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        radioGroupGUID: gerarGUID(),
        campo: this.pCampo,
        formData: {
            respostaOpcoes: []
        },
        isDirty: this.pIsDirty,
        campoIniciado: false
      };
    },
    computed: {
        opcoesOrdenadas() {
            const cloneOpcoes = [...this.campo.opcoes];
            cloneOpcoes.sort((a,b) => a.ordem - b.ordem);
            if (this.campo.hasOpcaoOutro) {
                cloneOpcoes.push({
                    label: 'Outro',
                    labelHtml: 'Outro',
                    ordem: -1
                })
            }
            return cloneOpcoes
        },
        isInvalida() {
            if (!this.required) return false;
            return this.isDirty && (!Array.isArray(this.formData.respostaOpcoes) || this.formData.respostaOpcoes.length == 0)
        },
        markupError() {
            return this.isPreenchimento && this.isInvalida
        }
    },
    watch: {
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        },
        pCampo: {
            immediate: true,
            handler(novo) {
                if (this.campoIniciado) return;

                let respostaDoCampo = null;
                if(novo?.isCampoSocio && Array.isArray(novo?.respostasSocios)) {
                    respostaDoCampo = novo.respostasSocios.find((resposta) => {
                        return (resposta.processoSocioId != null && resposta.processoSocioId == this.pSocioEmPreenchimento.socio.id) || (resposta.uuid != null && resposta.uuid == this.pSocioEmPreenchimento.socio.uuid)
                    })
                }
                const respostaPreenchimento = respostaDoCampo? respostaDoCampo.respostaOpcoes : this.pCampo.respostaOpcoes;
                this.formData.respostaOpcoes = respostaPreenchimento? respostaPreenchimento : [];
                this.campoIniciado = true;
                this.emitValue(this.formData);
            }
        },
    },
    methods: {
        setValue(event) {
            const value = [parseInt(event.target.value)];
            this.formData.respostaOpcoes = value;
            this.emitValue(this.formData)
            this.isDirty = true;
        },

        emitValue(value) {
            if(!this.campoIniciado) return;
            this.$emit('update:value', value)
        },
    }
  };
  </script>
  <style lang="scss" scoped>
    .control .radio input + span {
        font-weight: normal;
    }
  </style>